/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import * as AuthActions from '../store/auth.actions';
import { AuthState, initialState } from './auth.state';

export function authReducer(state = initialState, action: AuthActions.AuthActions): AuthState {
  switch (action.type) {
    case AuthActions.LOGIN:
      return {
        ...state,
        pending: true,
        error: null
      };
    case AuthActions.LOGIN_SUCCESS:
      console.log('LOGIN_SUCESS', state);
      return {
        ...state,
        pending: false,
        authInit: true,
        authenticated: true,
        user: action.payload,
        error: null
      };
    case AuthActions.LOGIN_FAILURE:
      return {
        ...state,
        pending: false,
        authenticated: false,
        user: null,
        error: action.payload
      };
    case AuthActions.INIT:
      const test = {
        ...state,
        ...action.payload,
        authInit: true,
      };
      console.log('AUTH_INIT', test);
      return test;
    case AuthActions.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
